export default {
    all: { method: 'GET', url: 'usuario' },
    active: { method: 'GET', url: 'usuario/ativos' },
    obter: { method: 'GET', url: 'usuario/obter{/id}' },
    create: { method: 'POST', url: 'usuario' },
    updatePassword: { method: 'PUT', url: 'usuario/password' },
    inactive: { method: 'DELETE', url: 'usuario{/id}' },
};